export const otpDeliveryMechanisms = {
  SMS: 'SMS',
  SMS_PHONE: 'SMS_PHONE',
  EMAIL: 'EMAIL'
};